module.exports = __webpack_public_path__ + "static/media/paillette.02ffbc93.gif";


//////////////////
// WEBPACK FOOTER
// ./src/client/images/paillette.gif
// module id = 219
// module chunks = 0